let containerCounter = 0;
export function createRendererContainer(domId) {
  let $wrapper = domId;
  if (typeof domId === 'string') {
    $wrapper = document.getElementById(domId);
  }
  if ($wrapper) {
    const $container = document.createElement('div');
    $container.style.cssText += `
      position: absolute;
      z-index:2;
      height: 100%;
      width: 100%;
      pointer-events: none;
    `;
    $container.id = `l7-scene-${containerCounter++}`;
    $container.classList.add('l7-scene');
    $wrapper.appendChild($container);
    return $container;
  }
  return null;
}

/**
 * 检测触发事件是否是在 marker/popup 上发生，若是则会发生冲突（发生冲突时 marker/popup 事件优先）
 * @param layerEvent
 * @returns
 */
export function isEventCrash(layerEvent) {
  var _layerEvent$target;
  let notCrash = true;
  // 获取图层鼠标事件中对应点击的 DOM 元素
  if ((layerEvent === null || layerEvent === void 0 || (_layerEvent$target = layerEvent.target) === null || _layerEvent$target === void 0 ? void 0 : _layerEvent$target.target) instanceof HTMLElement) {
    var _layerEvent$target2;
    let currentElement = layerEvent === null || layerEvent === void 0 || (_layerEvent$target2 = layerEvent.target) === null || _layerEvent$target2 === void 0 ? void 0 : _layerEvent$target2.target;
    while (currentElement) {
      var _currentElement;
      const classList = Array.from(currentElement.classList);
      if (classList.includes('l7-marker') || classList.includes('l7-popup')) {
        notCrash = false;
        break;
      }
      currentElement = (_currentElement = currentElement) === null || _currentElement === void 0 ? void 0 : _currentElement.parentElement;
    }
  }
  return notCrash;
}